import { AxiosInstance } from 'axios';
import { parseCompModules } from './utils';
import { CompModulesStatusEnum } from './types';

export const getCompModulesData = (api: AxiosInstance) => ({
  getModules: async (
    params: any,
    parseData: Function = parseCompModules,
  ): Promise<any> => {
    const { data } = await api.get(CompModulesStatusEnum.COMP_MODULES, {
      params,
    });
    return { ...data, data: parseData(data.data) };
  },
});

export const compModulesService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getCompModulesData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/comp-modules/compModulesService.ts